import get from 'lodash/get';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import * as actions from 'actions/reviewsActions/imageReviewsActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
const { ImageGalleryActions } = actions;
const defaultState = {
    url: '',
    asyncStatus: AsyncStatus.INIT,
    images: [],
    imagePositionMap: {},
    pageNumber: 1,
    hasMorePages: true
};
function flattenImages(slots) {
    return slots.reduce((imgs, slot) => {
        if (slot.widget && slot.widget.type === WidgetTypeV4.IMAGE_GRID_WIDGET) {
            return [...imgs, ...get(slot, 'widget.data.renderableComponents', [])];
        }
        return imgs;
    }, []);
}
function makePositionMap(images) {
    return images.reduce((map, image, i) => (Object.assign(Object.assign({}, map), { [get(image, 'value.imageId', '')]: i })), {});
}
export default function galleryReducer(state = defaultState, action) {
    switch (action.type) {
        case ImageGalleryActions.REQUEST:
            return Object.assign(Object.assign({}, state), { url: action.url, asyncStatus: AsyncStatus.LOADING });
        case ImageGalleryActions.SUCCESS:
            if (!get(action, 'data.slots'))
                return state;
            const pageNumber = get(action.requestContext, 'pageContext.pageNumber', 1);
            let images = flattenImages(action.data.slots);
            /*
                A bug was encountered on the RnR page wherein when the user clicked on one of the images from the list of User Images, sometimes a blacked out modal would appear. This happened because as soon as the modal opens up, more images are fetched in the background and if say the image at index i in the User Images list doesn't match the image present at the same index in the gallery images response this would lead to the assignment of the review for that particular image to fail. This happens as sometimes the cache population fails in UGC layer, causing a mismatch. To fix this, the N images from the User Images list is used as is, and the first N images of the page 1 response are skipped. One assumption here being that images in the User Images list will not be more than the ones returned in page 1 response.
            */
            images = pageNumber > 1 ? [...state.images, ...images] : [...state.images, ...images.slice(state.images.length)];
            const imagePositionMap = makePositionMap(images);
            return Object.assign(Object.assign({}, state), { url: action.url, asyncStatus: AsyncStatus.SUCCESS, images,
                imagePositionMap, hasMorePages: get(action.data, 'pageData.hasMorePages') || false, pageNumber });
        case ImageGalleryActions.ERROR:
            return Object.assign(Object.assign({}, state), { url: action.url, asyncStatus: AsyncStatus.ERROR });
        case ImageGalleryActions.RESET:
            return defaultState;
        case ImageGalleryActions.POPULATE:
            return {
                asyncStatus: AsyncStatus.INIT,
                url: action.url,
                images: action.images,
                imagePositionMap: makePositionMap(action.images),
                pageNumber: 0,
                hasMorePages: true
            };
        default:
            return state;
    }
}
